// @flow
import React, { useEffect, useState } from 'react';
//Components
import { Link } from 'react-router-dom';
import VisibilitySensor from 'react-visibility-sensor';
import { ProductPrice, ProgressiveImageLoader, priceConverter } from '../../common';
import { AddToCartButton } from '../../current-order';
//Types
import type { ProductImage } from '../../types/ProductImage';
//Styles
import './ProductSquare.css';
//Analytics
import * as Analytics from '../../common/analytics';
//Helpers
import { scaleConverter } from '../../common';

type Props = {
  productImage: ?ProductImage,
  productName: string,
  productManufacturer: string,
  productListPrice: number,
  productPrice: number,
  productUnit: string,
  productSlug: string,
  productId: number,
  defaultQuantity: number,
  incrementQuantity: number,
  inStock: boolean,
  isGiftCard: boolean,
  discontinued: boolean,
  setHoveredDept?: (dept: ?string) => void,
};

const ProductSquare = ({
  productSlug,
  productImage,
  productName,
  productPrice,
  productListPrice,
  productManufacturer,
  productUnit,
  productId,
  parentProductId,
  productTotalOnHand,
  defaultQuantity,
  inStock,
  discontinued,
  incrementQuantity,
  isGiftCard,
  analyticsViewSource,
  setHoveredDept = () => {},
}: Props) => {
  const [visibility, setVisibility] = useState(false);

  const price = scaleConverter(productPrice);
  const listPrice = scaleConverter(productListPrice);

  const productOnPromotion = listPrice > price;
  const productDiscount = productOnPromotion
    ? ((listPrice - price) / listPrice) * 100
    : null;

  useEffect(() => {
    if (visibility) {
      Analytics.logProductImpression(
        {
          variantId: productId,
          productId: parentProductId,
          name: productName,
          price: productPrice,
          manufacturer: productManufacturer,
          unitForQuantity: productUnit,
          totalOnHand: productTotalOnHand,
          listPrice: productListPrice,
          inStock: inStock,
          discontinued: discontinued,
          images: productImage ? [productImage] : [],
          incrementQuantity: incrementQuantity,
          defaultQuantity: defaultQuantity,
        },
        window.location.pathname,
        analyticsViewSource,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibility]);

  const convertedPrice = scaleConverter(
    price,
    productUnit,
  );
  const convertedListPrice = scaleConverter(
    listPrice,
    productUnit,
  );

  return (
    <VisibilitySensor
      onChange={isVisible => {
        setVisibility(isVisible);
      }}
    >
      <div className="product-square-main">
        <section className="search-result-square-image-section">
          <Link className="search-result-square-link" onClick={() => setHoveredDept(null)} to={`/produtos/${productSlug}/`}>
            {productOnPromotion && productDiscount >= 5 && (
              <div className="product-square-image-section-discount">
                <p>{Math.round(productDiscount)}%</p>
                <span>OFF</span>
              </div>
            )}
            <ProgressiveImageLoader
              selectedImage={productImage}
              imageToShow={'product'}
            />
          </Link>
        </section>

        <section className="search-result-square-info-section">
          <p className="search-result-square-variant">{productManufacturer}</p>
          <Link className="search-result-square-link" to={`/produtos/${productSlug}/`}>
            <h3 title={productName} className="search-result-square-title">
              {productName}
            </h3>
          </Link>

        </section>
        <div
          className={`card-product-price-main`}
        >
          <div className={`card-product-price-main-titles ${
            productOnPromotion ? 'card-product-price-promotion' : ''
          }`}>
          <h5>{priceConverter(convertedPrice)}</h5>
          {productOnPromotion && <h6>{priceConverter(convertedListPrice)}</h6>}
          </div>
          <p>
            Preço /
            {productUnit === 'g' || productUnit === 'kg'
              ? 'Kg'
              : 'un'}
          </p>
        </div>
        <section>
          <div className="search-result-square-button">
            {isGiftCard ? (
              <Link className="search-result-square-link" to={`/produtos/${productSlug}/`}>
                <AddToCartButton
                productId={productId}
                unitForQuantity={productUnit}
                defaultQuantity={defaultQuantity}
                incrementQuantity={incrementQuantity}
                inStock={inStock}
                // USE ANALYTICS
                analyticsEventType={'impression'}
                analyticsViewSource={'search result square'}
                largeSize={true}
                disable={true}
              />
              </Link>
            ) : (
              <AddToCartButton
                productId={productId}
                unitForQuantity={productUnit}
                defaultQuantity={defaultQuantity}
                incrementQuantity={incrementQuantity}
                inStock={inStock}
                // USE ANALYTICS
                analyticsEventType={'impression'}
                analyticsViewSource={'search result square'}
                largeSize={true}
              />
            )}
          </div>
        </section>
      </div>
    </VisibilitySensor>
  );
};

export default ProductSquare;
